import { BidiModule } from '@angular/cdk/bidi';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ParseDurationPipeModule } from '../format-duration/format-duration.pipe.module';
import { MediaProgressSliderComponent } from './media-progress-slider.component';
import { MediaProgressTooltipDirective } from './media-progress-tooltip.directive';

@NgModule({
  imports: [BidiModule, CommonModule, ParseDurationPipeModule],
  declarations: [MediaProgressSliderComponent, MediaProgressTooltipDirective],
  exports: [MediaProgressSliderComponent, MediaProgressTooltipDirective],
})
/**
 * Module with the duration pipe
 */
export class MediaProgressSliderComponentModule {}
